import React from 'react';

/**
 * Selectable card backed by a real radio/checkbox input with a label, used for
 * the use-case grid and primary selector. The styled input (filled checkbox /
 * radio) is the single selection signal alongside the brand border + tint, so
 * color is never the only cue (a11y) and there's no duplicate indicator.
 *
 * @param {Object} props
 * @param {'checkbox'|'radio'} props.type
 * @param {string} props.name
 * @param {string} props.value
 * @param {boolean} props.checked
 * @param {(value: string) => void} props.onChange
 * @param {React.ReactNode} [props.icon]
 * @param {string} props.label
 * @param {string} [props.description]
 * @param {boolean} [props.compact]   - tighter layout for the primary selector row
 */
const SelectableCard = ({
  type,
  name,
  value,
  checked,
  onChange,
  icon,
  label,
  description,
  compact,
}) => {
  return (
    <label className={`sel-card ${checked ? 'selected' : ''} ${compact ? 'compact' : ''}`}>
      <input
        type={type}
        name={name}
        value={value}
        checked={checked}
        onChange={() => onChange(value)}
        className="sel-card-input"
      />
      {icon && <span className="sel-card-icon" aria-hidden="true">{icon}</span>}
      <span className="sel-card-text">
        <span className="sel-card-label">{label}</span>
        {description && <span className="sel-card-desc">{description}</span>}
      </span>
    </label>
  );
};

export default SelectableCard;
